export enum LocalStorageKeys {
    callingProductId = 'alm-calling-product-name',
    qsAccessToken = 'access-token',
    qsRefreshToken = 'refresh-token',
    qsAccessTokenExpiration = 'access-token-expiration',
    seAccessToken = 'smart-exchange-user-login-token',
    almComps = 'alm-comps',
    almCompId = 'alm-comp-id',
    formCode = 'form-code',
    mlsToken = 'mls-token',
    defaultComp = 'current-comp-number',
    uuid = 'qs-uuid',
    p2id = 'p2id',
    totalUpdateNumber = 'total-update-number',
    debugByPPID = 'debug-ppid',
    showModalAnnouncements = 'show-modal-announcements',
    showBannerAnnouncements = 'show-banner-announcements',
}
